// extracted by mini-css-extract-plugin
module.exports = {"title":"marketplace-block_title__7s7sb","description":"marketplace-block_description__ZY8UT"};